import React from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { selectHasLoadError, selectIsLoadingProject } from '@ff-os/pdp-shared-redux/slices/projectLoadingSlice';
import { Alert } from '@ff-os/shared-react/components/alert/Alert';
import { Cell } from '@ff-os/shared-react/components/grid/Cell';
import { Grid } from '@ff-os/shared-react/components/grid/Grid';
import { WindowStackProvider } from '@ff-os/shared-react/context/window-stack/WindowStack';
import { WindowStackItem } from '@ff-os/shared-react/context/window-stack/WindowStackItem';
import { PhotoPrintsPdpDispatch, PhotoPrintsPdpState } from '@ff-scene-plugins/photo-prints-redux/store';
import { selectIsPhotoPrintsWindowOpen, setIsPhotoPrintsWindowOpen } from './_redux-ui';
import { PhotoPrintsWindow } from './components/PhotoPrintsWindow';

const _PhotoPrintsModalUi = ({
    isLoadingProject,
    hasLoadError,
    isOpen, setOpen
}: Props) => {

    const { t } = useTranslation();

    return (
        <>
            <Grid gap='s' direction='column'>
                {hasLoadError && (
                    <Cell>
                        <Alert icon='alert-triangle-exclamation' type='error'>
                            {t('load_project.error_message')}
                        </Alert>
                    </Cell>
                )}
            </Grid>
            <WindowStackProvider>
                {isOpen && !isLoadingProject && (
                    <WindowStackItem>
                        <PhotoPrintsWindow close={() => setOpen(false)} />
                    </WindowStackItem>
                )}
            </WindowStackProvider>
        </>
    );
};

type Props = {
    isLoadingProject: boolean;
    hasLoadError: boolean;
    isOpen: boolean;
    setOpen: (value: boolean) => void;
};

const mapStateToProps = (state: PhotoPrintsPdpState) => ({
    isLoadingProject: selectIsLoadingProject(state),
    hasLoadError: selectHasLoadError(state),
    isOpen: selectIsPhotoPrintsWindowOpen(state)
});

const mapDispatchToProps = (dispatch: PhotoPrintsPdpDispatch) => ({
    setOpen: (value: boolean) => dispatch(setIsPhotoPrintsWindowOpen(value))
});

export const PhotoPrintsModalUi = connect(
    mapStateToProps,
    mapDispatchToProps
)(_PhotoPrintsModalUi);